import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useFavorites } from "@/hooks/useFavorites";

const navItems = [
  { label: "首页", to: "/" },
  { label: "图片分类", to: "/gallery" },
  { label: "写真专题", to: "/photobooks" },
  { label: "娱乐资讯", to: "/news" },
  { label: "收藏", to: "/favorites" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { items } = useFavorites();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    if (!value) return;
    navigate(`/search?q=${encodeURIComponent(value)}`);
    setKeyword("");
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `relative px-1 py-2 text-sm font-medium transition-colors ${
      isActive
        ? "text-primary-600"
        : "text-foreground-700 hover:text-primary-600"
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-vip-diamond-fill text-lg"></i>
            </span>
            <span className="font-heading text-xl font-semibold tracking-wide text-foreground-950">
              美女网站
            </span>
          </Link>

          <nav className="hidden items-center gap-7 lg:flex">
            {navItems.map((item) => (
              <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === "/"}>
                {item.label}
                {item.to === "/favorites" && items.length > 0 && (
                  <span className="ml-1 rounded-full bg-accent-500 px-1.5 py-0.5 text-[10px] font-semibold text-background-50">
                    {items.length}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>

          <form
            onSubmit={handleSearch}
            className="hidden items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-1.5 md:flex"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索图片 / 写真 / 资讯"
              className="w-36 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-500 lg:w-44"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </form>

          <button
            type="button"
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 lg:hidden"
            aria-label="打开菜单"
          >
            <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-3 flex items-center gap-2 rounded-full border border-background-300 bg-background-100 px-3 py-2"
          >
            <i className="ri-search-line text-base text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索图片 / 写真 / 资讯"
              className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-500"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `flex items-center justify-between border-b border-background-100 py-3 text-sm font-medium ${
                    isActive ? "text-primary-600" : "text-foreground-700"
                  }`
                }
              >
                <span>{item.label}</span>
                {item.to === "/favorites" && items.length > 0 && (
                  <span className="rounded-full bg-accent-500 px-2 py-0.5 text-[10px] font-semibold text-background-50">
                    {items.length}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}